import { defineMessages } from 'react-intl';

export const customerRatingsOverviewCardMessages = defineMessages({
  header: {
    id: 'customerRatings.ratingsOverviewCard.header',
    defaultMessage: 'Bewertungsübersicht',
  },
});
